import actions from "@/store/modules/weather/actions";
import mutations from "@/store/modules/weather/mutations";
import state from "@/store/modules/weather/state";

export default {
    actions,
    mutations,
    state
}